// extracted by mini-css-extract-plugin
export var bounce = "_nv-1";
export var generatingText = "_nv-6";
export var lightning = "_nv-4";
export var popup = "_nv-5";
export var progressBar = "_nv-7";
export var progressFill = "_nv-8";
export var progressShimmer = "_nv-9";
export var progressText = "_nv-a";
export var shimmer = "_nv-3";
export var uploadIcon = "_nv-0";
export var uploadingText = "_nv-2";